/** Dev-run student phone: login identity + unlimited course / web document access */
export const DEV_RUN_LOGIN_PHONE = '9885750471';

/** OTP for dev-run login is delivered to this phone instead */
export const DEV_RUN_OTP_DELIVERY_PHONE = '9885750476';

export const normalizeStudentPhone = (phone) =>
  String(phone || '').replace(/\D/g, '').slice(-10);

export const isDevRunLoginPhone = (phone) =>
  normalizeStudentPhone(phone) === DEV_RUN_LOGIN_PHONE;

export const hasUnlimitedCourseAccess = (studentOrPhone) => {
  const phone =
    typeof studentOrPhone === 'string'
      ? studentOrPhone
      : studentOrPhone?.phone;
  return normalizeStudentPhone(phone) === DEV_RUN_LOGIN_PHONE;
};

/** Web PDF/image viewer bypass — dev-run phone only; regular students stay app-only */
export const hasWebDocumentAccess = (studentOrPhone) =>
  hasUnlimitedCourseAccess(studentOrPhone);
